import styled from '@emotion/styled';
import { preventFocusVisibleStyleClipping, pxToRem, Text } from '@lbcamden/lib-react';

export const BreadCrumbsRoot = styled.nav`
  ${preventFocusVisibleStyleClipping([0, 0, 1])}

  display: flex;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  width: 100%;
  margin: ${({ theme }) => theme.spacing([3, 0, 6])};
  overflow: auto;

  svg {
    height: ${pxToRem(5)};
    color: ${({ theme }) => theme.colors.textSecondary};
    transform: rotate(-90deg);
  }

  ${Text} {
    ${({ theme }) => theme.text.body2};
    color: inherit;
  }

  ${({ theme }) => theme.breakpoints.up('md')} {
    svg {
      height: ${pxToRem(7)};
    }

    ${Text} {
      ${({ theme }) => theme.text.body1}
      color: inherit;
    }
  }

  > * {
    flex-shrink: 0;
  }
`;
